export const checkCasesSubCasesBetweenUserAndApplicationForm =(props)=>{
    const {user,applicationCaseTypeId,applicationSubCaseTypeId}=props;
    let caseIsAllowed = false;
    let subCasesIsAllowed = false;
    if (user.solicitorUserAllowedToApplyForDisbursements &&
        user.allowedDisbursementsCaseIdList &&
        user.allowedDisbursementsCaseIdList.length > 0
    ) {
        caseIsAllowed = user.allowedDisbursementsCaseIdList.includes(applicationCaseTypeId);
        if (!caseIsAllowed) {
            return true;
        };
        if (applicationSubCaseTypeId !== null &&
            user.allowedDisbursementsSubCaseIdList &&
            user.allowedDisbursementsSubCaseIdList.length > 0) {
            subCasesIsAllowed = user.allowedDisbursementsSubCaseIdList.includes(applicationSubCaseTypeId);
            if(!subCasesIsAllowed){
                return true;
            }
            else{
                return false;
            };
        }
        else if(applicationSubCaseTypeId===null){
            return false;
        };
    };
    return true;
}